import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/atoms/Button';

interface ExitInterviewConfirmModalProps {
  open: boolean;
  loading?: boolean;
  enabled?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const ExitInterviewConfirmModal: React.FC<ExitInterviewConfirmModalProps> = ({
  open,
  loading = false,
  enabled = true,
  onCancel,
  onConfirm,
}) => {
  const { t } = useTranslation('interview');

  if (!open || !enabled) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md mx-auto shadow-xl">
        <h3 className="text-lg font-medium text-dark-invirtus mb-4 font-heading">{t('live.exit_modal.title')}</h3>
        <p className="text-sm text-dark-invirtus mb-6 font-body">
          {t('live.exit_modal.message')}
        </p>
        <div className="flex justify-end space-x-3">
          <Button
            onClick={onCancel}
            label={t('live.actions.cancel')}
            type="outlined"
            intent="secondary"
            disabled={loading}
          />
          <Button
            onClick={onConfirm}
            label={loading ? t('live.exit_modal.leaving') : t('live.exit_modal.leave')}
            type="contained"
            intent="danger"
            disabled={loading}
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
};
